"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Iris = require("iris");
var lodash_1 = require("lodash");
var defaultParams = {
    adults: 2,
    juveniles: 0,
    children: 0,
    ship: null,
    // maxResults: null,
    // portID: null,
    regionID: null,
    timeFrom: null,
    timeTo: null,
    departureAirport: null,
    travelDuration: null,
    extraFilter: null,
};
function init(store, params) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, routes, regions, airports, ships, shipList, routesCopy, reducedResults, regionID;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Promise.all([
                        Iris.client.searchCruisesGrouped({
                            adults: params.adults,
                            juveniles: params.juveniles,
                            children: params.children,
                        }),
                        Iris.client.searchFileRegions(),
                        Iris.client.searchFileAiports(),
                        Iris.client.searchFileShips(),
                    ])];
                case 1:
                    _a = _b.sent(), routes = _a[0], regions = _a[1], airports = _a[2], ships = _a[3];
                    shipList = lodash_1.map(ships, function (ship) {
                        return {
                            id: ship.id,
                            name: ship.name,
                        };
                    });
                    // console.log('shipList:', shipList)
                    store.commit('SET_REGIONS', regions);
                    store.commit('SET_BACKGROUND_IMAGES', params.backgrounds);
                    if (routes.length === store.state.searchResults.length) {
                        return [2 /*return*/];
                    }
                    store.commit('SET_AIRPORT_INFO', airports);
                    store.commit('SET_SHIP_LIST', shipList);
                    routesCopy = JSON.parse(JSON.stringify(routes));
                    store.commit('SET_RESULTS', routesCopy);
                    reducedResults = lodash_1.get(params, 'reducedResults', undefined);
                    if (reducedResults) {
                        store.commit('SET_REDUCED_RESULTS', reducedResults);
                    }
                    regionID = lodash_1.get(params, 'regionID', undefined);
                    if (regionID) {
                        store.commit('SET_PARAM', { key: 'regionID', value: regionID });
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.init = init;
function flightPrices(store, airport) {
    return __awaiter(this, void 0, void 0, function () {
        var flights;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Iris.client.searchFlightPrices(airport)];
                case 1:
                    flights = _a.sent();
                    store.commit('SET_FLIGHT_PRICES', {
                        airportCode: airport,
                        flights: flights,
                    });
                    return [2 /*return*/];
            }
        });
    });
}
exports.flightPrices = flightPrices;
function updateParams(store, params) {
    return __awaiter(this, void 0, void 0, function () {
        var ignoreKeys, allPersons, _a, _b, _i, key, params_1, cruises, cruisesCopy;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    ignoreKeys = ['allPersons', 'adults', 'juveniles', 'children'];
                    allPersons = params['allPersons'];
                    _a = [];
                    for (_b in params)
                        _a.push(_b);
                    _i = 0;
                    _c.label = 1;
                case 1:
                    if (!(_i < _a.length)) return [3 /*break*/, 5];
                    key = _a[_i];
                    if (!key) {
                        return [2 /*return*/];
                    }
                    if (!(key === 'adults' || key === 'juveniles' || key === 'children')) return [3 /*break*/, 3];
                    params_1 = lodash_1.merge({}, lodash_1.pick(store.rootGetters[allPersons], ['adults', 'juveniles', 'children']));
                    return [4 /*yield*/, Iris.client.searchCruisesGrouped(params_1)];
                case 2:
                    cruises = _c.sent();
                    cruisesCopy = JSON.parse(JSON.stringify(cruises));
                    store.commit('SET_RESULTS', cruisesCopy);
                    store.commit('PARAMS_TOUCHED');
                    store.commit('SET_PARAM', { key: key, value: params_1[key] });
                    _c.label = 3;
                case 3:
                    if (key === 'departureAirport' && params[key]) {
                        store.dispatch('flightPrices', params[key]);
                    }
                    if (!ignoreKeys.includes(key)) {
                        store.commit('PARAMS_TOUCHED');
                        store.commit('SET_PARAM', { key: key, value: params[key] });
                    }
                    _c.label = 4;
                case 4:
                    _i++;
                    return [3 /*break*/, 1];
                case 5: return [2 /*return*/];
            }
        });
    });
}
exports.updateParams = updateParams;
function setSearchButtonTouched(store, value) {
    store.commit('SEARCH_BUTTON_TOUCHED', value);
}
exports.setSearchButtonTouched = setSearchButtonTouched;
function resetSearch(store) {
    return __awaiter(this, void 0, void 0, function () {
        var key;
        return __generator(this, function (_a) {
            // await store.dispatch('updateParams', defaultParams)
            for (key in defaultParams) {
                if (!key) {
                    return [2 /*return*/];
                }
                store.commit('SET_PARAM', { key: key, value: defaultParams[key] });
            }
            store.commit('SEARCH_BUTTON_TOUCHED', false);
            store.commit('PARAMS_TOUCHED', false);
            return [2 /*return*/];
        });
    });
}
exports.resetSearch = resetSearch;
// export everything compliant to the vuex specification for actions
exports.default = {
    init: init,
    flightPrices: flightPrices,
    updateParams: updateParams,
    setSearchButtonTouched: setSearchButtonTouched,
    resetSearch: resetSearch,
};
//# sourceMappingURL=actions.js.map